import { AxiosInstance } from 'axios';

export type JobStatusGetResponse = {
  tender: number;
  declined: number;
  request: number;
};

export class JobStatusService {
  instance: AxiosInstance;
  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  get() {
    return this.instance.get<JobStatusGetResponse>('/jobs/counts');
  }
}
